module.exports = __webpack_public_path__ + "static/media/grillades.1cf1fd79.jpg";